module.exports = __webpack_public_path__ + "img/Photo_5__Third_Canal_2007_5_42.b3078fc9.jpg";